import { useEffect, useState } from "react";
import { Bell, BellRing, BellOff } from "lucide-react";
import { toast } from "sonner";
import {
  pushSupported, isPushEnabled, enablePushNotifications,
  disablePushNotifications, sendTestPush,
} from "../lib/push";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const PushBell = () => {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const supported = pushSupported();

  useEffect(() => { isPushEnabled().then(setEnabled); }, []);

  const enable = async () => {
    setBusy(true);
    try {
      const res = await enablePushNotifications();
      if (res.ok) { setEnabled(true); toast.success("Notifications ON — ab updates phone par aayenge 🔔"); }
      else toast.error(res.error || "Could not enable notifications");
    } finally { setBusy(false); }
  };

  const disable = async () => {
    setBusy(true);
    try { await disablePushNotifications(); setEnabled(false); toast.success("Notifications OFF"); }
    finally { setBusy(false); }
  };

  const test = async () => {
    try {
      const res = await sendTestPush();
      if (res.ok && res.sent > 0) toast.success(`Test bheja gaya (${res.sent} device)`);
      else toast.error("Koi subscribed device nahi mila — pehle Enable karein.");
    } catch { toast.error("Test failed"); }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="relative h-9 w-9 inline-flex items-center justify-center rounded-full hover:bg-muted transition-colors"
          title="Notifications"
          data-testid="push-bell-trigger"
        >
          {enabled ? <BellRing className="h-5 w-5 text-primary" /> : <Bell className="h-5 w-5 text-muted-foreground" />}
          {enabled && <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-emerald-500" />}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Push notifications</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {!supported && (
          <div className="px-2 py-2 text-xs text-muted-foreground" data-testid="push-unsupported">
            Is browser par supported nahi. iPhone par pehle app ko <b>Add to Home Screen</b> karein, phir kholein.
          </div>
        )}
        {supported && !enabled && (
          <DropdownMenuItem onClick={enable} disabled={busy} data-testid="push-enable-item">
            <BellRing className="h-4 w-4 mr-2" /> Enable notifications
          </DropdownMenuItem>
        )}
        {supported && enabled && (
          <>
            <DropdownMenuItem onClick={test} data-testid="push-test-item">
              <Bell className="h-4 w-4 mr-2" /> Send test notification
            </DropdownMenuItem>
            <DropdownMenuItem onClick={disable} disabled={busy} className="text-red-600" data-testid="push-disable-item">
              <BellOff className="h-4 w-4 mr-2" /> Turn off
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
